export const setCareers = (value, page, limit, count) => {
    return {
      type: 'SET_CAREERS',
      payload: { data: value, page, limit, count }
    };
  };